import Alpine from "alpinejs";
import mixitup from "mixitup";

const LOCATION = window.location;

Alpine.data("projectContainer", () => ({
    open: false,
    key: Alpine.$persist(null),
    value: Alpine.$persist(null),
    getFilter() {
        return this.key && this.value ? `.mix-${this.key}-${this.value}` : "all";
    },
    init() {
        if (LOCATION.hash.substring(1)) {
            this.setValuesFromHash();
        }
        const mixer = mixitup(this.$refs.mixitup, {
            load: { filter: this.getFilter() },
        });

        window.addEventListener(
            "hashchange",
            () => {
                this.setValuesFromHash();
                mixer.filter(this.getFilter());
            },
            false
        );
    },
    setValuesFromHash() {
        const values = getHashValues();
        this.key = values[0];
        this.value = values[1];
    },
    list: (key) => ({
        ["@keydown.window.escape"]() {
            this.open = false;
        },
        ["@click.away"]() {
            if (this.open == key) {
                this.open = false;
            }
        },
    }),
    button: (key) => ({
        [":class"]() {
            return this.key == key && "text-terracota";
        },
        [":aria-expanded"]() {
            return this.open == key;
        },
        ["@click"]() {
            this.open = this.open == key ? false : key;
        },
    }),
    entry: (key, value) => ({
        [":class"]() {
            return this.value == value && this.key == key && "text-terracota";
        },
        ["@click"]() {
            this.key = key;
            this.value = value;
        },
    }),
}));

function getHashValues() {
    const HASH = LOCATION.hash.substring(1);
    setTimeout(() => {
        history.replaceState(null, null, LOCATION.pathname);
    }, 300);
    if (HASH) {
        let values = HASH.split("/");
        if (values[1]) {
            values[1] = Number(values[1]) || values[1];
            return values;
        }
    }
    return [null, null];
}
